import { ITokenService } from '../../../core/config/gql/TokenService';
import LarvaWsClientWrapper from './LarvaWsClientWrapper';
import larvaConfig from '../../../core/config/larva/general';
import { IWebsocketErrorService } from './WebsocketErrorService';

class DeviceConnectionGenerator {
    #tokenService: ITokenService;
    #errorService: IWebsocketErrorService;

    constructor(tokenService: ITokenService, errorService: IWebsocketErrorService) {
        this.#tokenService = tokenService;
        this.#errorService = errorService;
    }

    generate(deviceId: string, unitId: string): LarvaWsClientWrapper {
        return new LarvaWsClientWrapper(
            deviceId,
            unitId,
            this.#tokenService.getToken(),
            this.#errorService.handleError,
            this.#errorService.handleRemoveError,
            {
                server: larvaConfig.deviceProxy,
                timeout: larvaConfig.deviceTimeout,
            },
        );
    }
}

export default DeviceConnectionGenerator;
